import React from 'react';
import { Navigate } from 'react-router-dom';

// Keep the old URL working while the FAQ content lives on the Help page.
const FAQ: React.FC = () => <Navigate to="/help#faq" replace />;

export default FAQ;
